import React, { ReactElement } from 'react';
import { Skeleton as CartSkeleton } from 'b2b-components/theme/components/Cart/Skeleton';
import { useBreadcrumbs } from 'b2b-apps/core/breadcrumbs/hooks';
import { Skeleton as CartSummarySkeleton } from 'b2b-apps/shop/cart/components/CartSummary/Skeleton';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';

export const CartPageSkeleton = (): ReactElement => {
  const t = useTranslate();

  useBreadcrumbs([]);

  return (
    <div className='Content cds-Skeleton-Wrapper--Pulse'>
      <div className='row'>
        <div className='col-lg-12'>
          <h1 className='PageTitle'>{t('Shopping cart')}</h1>
        </div>
      </div>

      <div className='row'>
        <section className='col-lg-8 pr-lg-3 CartList'>
          <CartSkeleton>
            <CartSkeleton.Item />
            <CartSkeleton.Item />
            <CartSkeleton.Item />
          </CartSkeleton>
        </section>

        <section className='col-lg-4 pl-lg-3 CartSummaryBox'>
          <CartSummarySkeleton />
        </section>
      </div>
    </div>
  );
};
